
import { createApp } from 'vue'
import App from './App.vue'
import VueKonva from "vue-konva";
import axios from 'axios';


import { library } from "@fortawesome/fontawesome-svg-core";
import { faPlus, faMinus, faAlignLeft, faAlignCenter, faAlignRight, faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faPlus, faMinus, faAlignLeft, faAlignCenter, faAlignRight, faArrowLeft, faArrowRight);


const app = createApp(App).component("font-awesome-icon", FontAwesomeIcon).use(VueKonva)
app.config.globalProperties.axios=axios

app.mount('#app')


